import { getAxiosApiClientByUser } from './axiosInstance'

interface UpdatePageRequest {
  siteHsrId?: number
}

export const updatePage = async (
  pageId: string,
  payload: UpdatePageRequest
) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.put(
      `/pages/update-by-page-id/${pageId}`,
      payload
    )
    return response.data
  } catch (error) {
    console.error('Error while updating page', JSON.stringify(error))
    throw new Error(`Error while updating page`)
  }
}

export const getPageDataById = async (pageId: string) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get(`/pages/get-page/${pageId}`)
    return response.data
  } catch (error) {
    console.error('Error while fetching page', JSON.stringify(error))
    throw new Error(`Error while fetching page`)
  }
}

export const saveCustomPage = async (
  landing_page_id: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: Record<string, any>,
  name: string,
  utm_params?: string | null,
  url?: string,
  page_id?: string
) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.post('/pages/save-custom-page', {
      landing_page_id,
      content,
      page_name: name,
      utm_params,
      sub_domain: url,
      page_id
    })
    return response.data
  } catch (error) {
    console.error('Error while saving custom page', JSON.stringify(error))
    throw new Error(`Error while saving custom page`)
  }
}

export const deletePageById = async (pageId: string) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.delete(`/pages/delete-page/${pageId}`)
    return response.data
  } catch (error) {
    console.error('Error while deleting page', JSON.stringify(error))
    throw new Error(`Error while deleting page`)
  }
}

export const duplicatePageById = async (pageId: string) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.post(
      `/pages/create-duplicate-page/${pageId}`
    )
    return response.data
  } catch (error) {
    console.error('Error while duplicating page', JSON.stringify(error))
    throw new Error(`Error while duplicating page`)
  }
}
